import { BigNumber } from 'bignumber.js'

import { Address } from '@root/entities/address/Address'
import { CurrencyAddress } from '@root/entities/currency'
import { MakerAddress } from '@root/entities/trade/model/maker-address'

import type { ServicesApi } from '@root/shared/api'

export interface PairInitTxCreator {
  address: MakerAddress
  balanceInToken: BigNumber | undefined
  buyVolumeInUsd: BigNumber | undefined
  sellVolumeInUsd: BigNumber | undefined
  buys: number | undefined
  sells: number | undefined
  lastTx:
    | {
        at: Date
        amountInToken: BigNumber
        amountInUsd: BigNumber
        operation: 'buy' | 'sell'
      }
    | undefined
  funding: PairFunding | undefined
  quoteTokensBurned: BigNumber | undefined
  quoteTokensBurnedPercentage: BigNumber | undefined
}

export interface PairFunding {
  at: Date
  by: Address
  amount: BigNumber
  token: CurrencyAddress
}

export const pairInitTxCreatorFromDto = (
  dto: ServicesApi.PairInitTxCreatorDto,
): PairInitTxCreator => {
  return {
    address: MakerAddress(dto.address),
    balanceInToken: dto.balanceInToken
      ? BigNumber(dto.balanceInToken)
      : undefined,
    buyVolumeInUsd: dto.buyVolumeInUsd
      ? BigNumber(dto.buyVolumeInUsd)
      : undefined,
    sellVolumeInUsd: dto.sellVolumeInUsd
      ? BigNumber(dto.sellVolumeInUsd)
      : undefined,
    buys: dto.buys,
    sells: dto.sells,
    lastTx: dto.lastTx
      ? {
          at: new Date(dto.lastTx.at),
          amountInToken: BigNumber(dto.lastTx.amountInToken),
          amountInUsd: BigNumber(dto.lastTx.amountInUsd),
          operation: dto.lastTx.operation,
        }
      : undefined,
    funding: dto.funding
      ? {
          at: new Date(dto.funding.at),
          by: Address(dto.funding.by),
          amount: BigNumber(dto.funding.amount),
          token: CurrencyAddress(dto.funding.token),
        }
      : undefined,
    quoteTokensBurned: dto.quoteTokensBurned
      ? BigNumber(dto.quoteTokensBurned)
      : undefined,
    quoteTokensBurnedPercentage: dto.quoteTokensBurnedPercentage
      ? BigNumber(dto.quoteTokensBurnedPercentage)
      : undefined,
  }
}
